import React from "react";

const VideoCustom = ({ srcVideo, srcPoster }) => {
  return (
    <video
      width="100%"
      height="auto"
      controls
      autoPlay={true}
      playsInline
      controlsList="nodownload"
      onContextMenu="return false;"
      poster={require(`../../assets/images/${srcPoster}.jpg`)}
    >
      <source
        src={require(`../../assets/videos/${srcVideo}.mp4`)}
        type="video/mp4"
      />
      <source
        src={require(`../../assets/videos/${srcVideo}.webm`)}
        type="video/webm"
      />
      <source
        src={require(`../../assets/videos/${srcVideo}.ogv`)}
        type="video/ogg"
      />
      Your browser does not support the video tag.
    </video>
  );
};

export default VideoCustom;
